import { useEffect, useRef, useState } from "react";
import { accountingCRUD } from "../../../actions/accounting";
import { set } from "lodash";
import { Loader } from "rsuite";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { char, number } from "../../../utils";
import moment from "moment";


export const AccountTransactionData = (props) => {
    const { open, setOpen, payerId, name, reg } = props;
    const [loadingDebit, setLoadingDebit] = useState(false);
    const [loadingCredit, setLoadingCredit] = useState(false);
    const [debit, setDebit] = useState([]);
    const [credit, setCredit] = useState([]);
    const tableRef = useRef();

    useEffect(() => {
      if (payerId) {
        setLoadingDebit(true);
        setLoadingCredit(true);
        setTimeout(() => {
          accountingCRUD
            .loadAccountTransaction(payerId)
            .then((resp) => {
              setDebit(resp.data);
            })
            .catch(() => {})
            .finally(() => {
              setLoadingDebit(false);
            });
        }, 1000);
        setTimeout(() => {
          accountingCRUD
            .loadAccountPayment(payerId)
            .then((resp) => {
              setCredit(resp.data);
            })
            .catch(() => {})
            .finally(() => {
              setLoadingCredit(false);
            });
        }, 1000);
      }
    }, [payerId]);

    const allTransactions = [
      ...debit.map((d) => ({
        date: d.control_number_date,
        description: d.bill_description,
        amount: d.equivalent_amount,
        type: "invoice",
      })),
      ...credit.map((c) => ({
        date: c.trxdttm?.split("T")[0],
        description: c.description,
        amount: c.paidamount,
        type: "payment",
      })),
    ];

    const handlePrint = useReactToPrint({
      content: () => tableRef.current,
      documentTitle: `AccountTransactions_${payerId}`,
    });

    const handleExportExcel = () => {
      const worksheet = XLSX.utils.json_to_sheet(allTransactions);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
      XLSX.writeFile(workbook, `AccountTransactions_${payerId}.xlsx`);
    };

    const totalDebit = debit.reduce(
      (sum, item) => sum + parseFloat(item.equivalent_amount || 0),
      0
    );
    const totalCredit = credit.reduce(
      (sum, item) => sum + parseFloat(item.paidamount || 0),
      0
    );
    const balance = totalCredit - totalDebit;

    let balanceColor = "text-primary";
    if (balance > 0) balanceColor = "text-success";
    else if (balance < 0) balanceColor = "text-danger";

    const isLoading = loadingDebit || loadingCredit;

    return (
      <>
        <div
          className={`modal fade ${open ? "show" : ""}`}
          style={{ display: open ? "block" : "none" }}
          id="accountTransactionModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="accountTransactionModalLabel"
          aria-hidden={!open}
        >
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header justify-content-between">
                <h5
                  className="modal-title w-100"
                  id="accountTransactionModalLabel"
                >
                  <strong>Account Transactions</strong>
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setOpen(false)}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <hr />
              <div className="modal-body">
                {isLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "200px" }}
                  >
                    <Loader size="lg" content="Loading transactions..." />
                  </div>
                ) : (
                  <>
                    <div className="row">
                      <div className="mb-3 text-end">
                        <button
                          className="btn btn-outline-success btn-sm me-2"
                          onClick={handleExportExcel}
                        >
                          Export to Excel
                        </button>
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={handlePrint}
                        >
                          Print to PDF
                        </button>
                      </div>
                    </div>
                    <div ref={tableRef}>
                      <div className="row printHead">
                        <div className="col-12">
                          <div className="clearfix">
                            <div className="text-center">
                              <div
                                className="mb-2 text-center"
                                style={{ marginTop: -5 }}
                              >
                                <span>
                                  <img
                                    src="assets/images/suza.jpeg"
                                    height={100}
                                    alt=""
                                  />
                                </span>
                              </div>
                              <p className="h6 fs-16 text-primary">
                                Revolution Government of Zanzibar
                              </p>
                              <p className="h6 fs-15 text-primary fw-bold mb-4">
                                State University of Zanzibar
                              </p>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <h6 className="text-center text-muted">
                            {char.toUpperCase(name)}
                            <br />
                            {char.toUpperCase(reg)}
                          </h6>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        {/* Debit Table */}
                        <div className="col-md-6 pe-1">
                          <table className="table table-bordered table-sm">
                            <thead className="table-light text-center">
                              <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Control No</th>
                                <th>Description</th>
                                <th>Dr</th>
                              </tr>
                            </thead>
                            <tbody>
                              {debit?.length > 0 ? (
                                debit.map((dt, i) => (
                                  <tr key={i}>
                                    <td className="text-center">{i + 1}</td>
                                    <td>
                                      {moment(dt.control_number_date).format(
                                        "DD. MM. YYYY"
                                      ) || "N/A"}
                                    </td>
                                    <td>{dt.control_number || "N/A"}</td>
                                    <td>
                                      {char.toTitleCase(dt.bill_description) ||
                                        "N/A"}
                                    </td>
                                    <td className="text-end">
                                      {number.fNumberDoublePoint(
                                        dt.equivalent_amount
                                      ) || "0.00"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="4"
                                    className="text-center text-muted"
                                  >
                                    No debit transactions
                                  </td>
                                </tr>
                              )}
                              <tr className="table-active fw-bold">
                                <td colSpan="4" className="text-center">
                                  Total
                                </td>
                                <td className="text-end">
                                  {number.fNumberDoublePoint(totalDebit)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {/* Credit Table */}
                        <div className="col-md-6 ps-1">
                          <table className="table table-bordered table-sm">
                            <thead className="table-light text-center">
                              <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Control No</th>
                                <th>Description</th>
                                <th>Cr</th>
                              </tr>
                            </thead>
                            <tbody>
                              {credit?.length > 0 ? (
                                credit.map((dt, i) => (
                                  <tr key={i}>
                                    <td className="text-center">{i + 1}</td>
                                    <td>
                                      {moment(dt.trxdttm?.split("T")[0]).format(
                                        "DD. MM. YYYY"
                                      ) || "N/A"}
                                    </td>
                                    <td>{dt.control_number || "N/A"}</td>
                                    <td>
                                      {char.toTitleCase(dt.description) ||
                                        "N/A"}
                                    </td>
                                    <td className="text-end">
                                      {number.fNumberDoublePoint(
                                        dt.paidamount
                                      ) || "0.00"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="4"
                                    className="text-center text-muted"
                                  >
                                    No credit transactions
                                  </td>
                                </tr>
                              )}
                              <tr className="table-active fw-bold">
                                <td colSpan="4" className="text-center">
                                  Total
                                </td>
                                <td className="text-end">
                                  {number.fNumberDoublePoint(totalCredit)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* Balance Row */}
                      <div className="row mt-3">
                        <div className="col-md-12 text-center">
                          <h6 className={`fw-bold ${balanceColor}`}>
                            Balance: {number.fNumberDoublePoint(balance)}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <hr />
              <div className="modal-footer">
                <button
                  className="btn btn-danger"
                  onClick={() => setOpen(false)}
                >
                  <i className="bi bi-x-circle" /> Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {open && (
          <div
            className="modal-backdrop fade show"
            style={{ display: "block" }}
          />
        )}
      </>
    );

}